export var CDN_PREFIX = 'https://d2pj2twnjx3fya.cloudfront.net/frontend-packages/viewer-container/';